import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, } from '@mui/material';
import { compressionByField, plural, prettyFloat, unixToDateTime } from 'utils';
const table_names = ['Дата', 'Предыдущее', 'Новое'];
export const WorkStateHistoryList = memo(function WorkStateHistoryList(props) {
    const { work_state } = props;
    const history = useMemo(() => work_state != null
        ? [
            ...work_state.mileage.edit_history.map((item) => ({
                ...item,
                type: 'mileage',
            })),
            ...work_state.moto_hours.edit_history.map((item) => ({
                ...item,
                type: 'moto_hours',
            })),
        ]
        : [], [work_state]);
    if (history.length == 0) {
        return null;
    }
    return (_jsxs(TableContainer, { children: [_jsxs(Typography, { variant: "subtitle1", color: "textSecondary", sx: { ml: 1 }, children: ["\u0414\u0430\u043D\u043D\u044B\u0435 \u043E \u043F\u0440\u043E\u0431\u0435\u0433\u0435 \u043C\u0435\u043D\u044F\u043B\u0438\u0441\u044C", ' ', _jsxs("strong", { children: [history.length, "\u00A0", plural(history.length, 'раз', 'раза', 'раз')] })] }), _jsxs(Table, { size: "small", children: [_jsx(TableHead, { children: _jsx(TableRow, { children: table_names.map((name, index) => (_jsx(TableCell, { variant: "head", children: _jsx("strong", { children: name }) }, index))) }) }), _jsx(TableBody, { children: history
                            .sort(compressionByField('time', undefined, true))
                            .map(({ time, type, old_value, value }, index) => (_jsxs(TableRow, { hover: true, children: [_jsx(TableCell, { children: unixToDateTime(time) }), _jsx(TableCell, { children: prettyFloat(old_value, 1) }), _jsx(TableCell, { children: `${prettyFloat(value, 1)} ${type == 'mileage' ? ' Км' : ' М/ч'}` })] }, index))) })] })] }));
});
